import { Component, OnInit } from '@angular/core';
import { DateRangeCIF } from '../../../shared/viewmodels/UtilityObj';
import { Store } from '@ngrx/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ValidationErrors, ValidatorFn } from '@angular/forms';
import { parseDate } from "devextreme/localization";
//import { toDate } from '@angular/common/src/i18n/format_date';

@Component({
  selector: 'app-daterange',
  templateUrl: './daterange.component.html',
  styleUrls: ['./daterange.component.css']
})
export class DaterangeComponent implements OnInit {
  public utilityobj: DateRangeCIF;
  message: any;
  public form: UntypedFormGroup;
  public datecompare = false;
  constructor(private store: Store<AppState>, private fb: UntypedFormBuilder) {
    this.utilityobj = new DateRangeCIF();
    this.store.select(getRegSearchState).subscribe(data => this.message = data);
    if (this.message.date.date[0] != null) {
      this.utilityobj.fromDate = this.message.date.date[0].fromDate;
      this.utilityobj.toDate = this.message.date.date[0].toDate;
    }
  }

  ngOnInit() {
    this.form = this.fb.group({
      'datefrom': [this.utilityobj.fromDate, Validators.required],
      'dateto': [this.utilityobj.toDate, Validators.required]
    }, { validators: this.dateCompareValidator });
    this.form.valueChanges.subscribe(value => {
      console.log(`dateform valueChanges: ${JSON.stringify(value)}`);

    });
  }

  dateCompareValidator(control: UntypedFormGroup): ValidationErrors | null {
    const FromDate = new Date(control.get('datefrom').value);
    const ToDate = new Date(control.get('dateto').value);
    const currDate = new Date();
    if (control.get('datefrom').touched && control.get('dateto').touched) {
      if (FromDate > currDate)
        return { 'fromdatefuture': true }
      else if (FromDate > ToDate && FromDate < currDate && ToDate < currDate) {
        return { datecompare: true }
      }
    }
     
    else if (FromDate > currDate)
      return { 'fromdatefuture': true }
    else
       return null;
  };
  
}

